import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/user/mfa/user.mfa.deletePhone.mutation.gql"
import type {
  UserDeleteMfaPhoneMutation,
  UserDeleteMfaPhoneMutationVariables,
} from "@/v2-backoffice-client/user/mfa/__types__/user.mfa.deletePhone.mutation"

type Options = MutationHookOptions<
  UserDeleteMfaPhoneMutation,
  UserDeleteMfaPhoneMutationVariables
>

export function useUserDeleteMfaPhoneMutation(options?: Options) {
  return useMutation<
    UserDeleteMfaPhoneMutation,
    UserDeleteMfaPhoneMutationVariables
  >(mutation, options)
}
